//@flow

import styled from 'styled-components';

import { Flex } from '../../v2/components';

export default styled(Flex).attrs({className: 'justify-content-around'})``;